import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const ModalAnnouncementStyle = {
  modalStyle: css`
    .ant-modal-content {
      background-color: transparent;
      padding: 0 !important;
      box-shadow: none !important;
    }
  `,
  close: css`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    .close-button {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .checkbox {
      padding: 4px 0;
      color: #fff;
    }
  `,
  container: css`
    height: 420px;
    background-color: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `,
  header: css`
    padding: 10px 0;
    background-color: rgb(252 143 0 / 1);
    align-items: center;
    justify-content: center;
    display: flex;
    border-bottom: 1px solid #ccc;

    h3 {
      color: #fff;
    }
  `,
  content: css`
    flex: 1;
  `,
  item: css`
    display: flex;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #d6d6d6;
    cursor: pointer;

    &:hover {
      background-color: ${theme.colors.neutrals[100]};
    }

    .message {
      fill: rgb(252 143 0 /1);
      width: 24px;
      height: 24px;
    }
    span {
      flex: 1;
      margin-left: 8px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: rgb(252 143 0 /1);
      font-size: 15px;
    }
    .arrow-right {
      fill: ${theme.colors.neutrals[500]};
    }
  `,
  footer: css`
    padding: 10px 0;
    background-color: rgb(252 143 0 / 1);
    align-items: center;
    justify-content: center;
    display: flex;
    border-top: 1px solid #ccc;
    h3 {
      color: #fff;
    }
  `,
  empty: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  `,
};
